<template>
  <div class="middle-banner">
    <div class="middle-banner-title">
      {{ hotinfo.title }}
    </div>
    <!-- <div> -->
    <el-row
      :gutter="20"
      type="flex"
      justify="space-between"
      class="middle-banner-main"
    >
      <el-col
        :xs="24"
        :sm="12"
        :md="12"
        :lg="6"
        :xl="6"
        v-for="(item, index) in hotinfo?.content"
        :key="index"
      >
        <div
          class="middle-banner-item"
          @click="
            hotSearch(
              item.fromCity,
              item.arrCity,
              item.fromCityCode,
              item.arrCityCode,
              item.newDate
            )
          "
        >
          <img class="middle-banner-img" :src="item.img" alt="" />
          <div class="middle-banner-item-text">
            <div class="middle-banner-item-title">
              <el-tooltip
                class="depcity"
                effect="dark"
                :content="item.desc.left"
                placement="bottom-end"
              >
                <span>{{ item.title.left }}</span>
              </el-tooltip>

              <span>{{ item.title.right }}</span>
            </div>
            <div class="middle-banner-item-desc">
              <el-tooltip
                class="depcity"
                effect="dark"
                :content="item.desc.left"
                placement="bottom-end"
              >
                <span>{{ item.desc.left }}</span>
              </el-tooltip>
              <!-- <span>{{ item.desc.left }}</span> -->
              <span>{{ item.desc.right }}</span>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- </div> -->
  </div>
</template>

<script>
// import dataList from "./dataList";
import CurrecyMixins from "@/utils/CurrencyMixins";
export default {
  name: "middleBanner",
  mixins: [CurrecyMixins],
  props: {
    hotinfo: {
      type: Object,
      require: true,
      default: () => ({})
    },
  },
  computed: {
    dataList() {
      return this.hotinfo?.content || [];
    },
  },
  data() {
    return {
      // dataList,
      // Currency: "AUD",
    };
  },
  created() {
    // this.Currency = sessionStorage.getItem("Currency");
  },
  methods: {
    hotSearch(fromCity, toCity, fromCityCode, toCityCode, oneWayTime) {
      // // console.log(fromCity, toCity, oneWayTime);
      let autoCompletes = {
        kind: 1, //单程1 往返2
        fromCity: fromCity,
        fromCityCode: fromCityCode, // 从哪
        toCity: toCity,
        toCityCode: toCityCode, // 去哪
        oneWayTime: oneWayTime, // 单程时间
        roundTripTime: [], // 双程时间
        adultNumber: 1, //成人人数
        childNumber: 0, //儿童人数
      };
      var searchForm = JSON.stringify(autoCompletes);
      // // console.log(searchForm);
      window.sessionStorage.setItem("searchForm", searchForm);
      this.$router.push({
        path: "/flights",
        query: {
          now: new Date().getTime(),
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./middleBanner.scss";
@import "./mmiddleBanner.scss";
</style>
